<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from '../../../../../../composables/useAccount';
import {
  conversationUrl,
  frontendURL,
} from '../../../../../../helper/URLHelper';

const props = defineProps({
  conversationIds: {
    type: Array,
    default: () => [],
  },
});

const { t } = useI18n();
const { accountId } = useAccount();

const idSearchQuery = ref('');

const filteredConversationIds = computed(() => {
  if (!idSearchQuery.value) return props.conversationIds;
  return props.conversationIds.filter(id =>
    String(id).includes(idSearchQuery.value)
  );
});

const getConversationRoute = conversationId => {
  const relativePath = conversationUrl({
    accountId: accountId.value,
    id: conversationId,
  });
  return frontendURL(relativePath);
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <div>
      <div class="flex justify-between items-center mb-2">
        <span class="text-xs text-n-slate-11">
          {{ t('BROADCASTS.CONVERSATION_IDS') }}
        </span>
      </div>

      <input
        v-if="conversationIds.length > 0"
        v-model="idSearchQuery"
        type="text"
        :placeholder="t('BROADCASTS.SEARCH_ID_PLACEHOLDER', 'Search ID...')"
        class="w-full mb-3 px-3 py-1.5 text-xs bg-n-alpha-1 border border-n-strong rounded-md text-n-slate-12 focus:outline-none focus:border-blue-500"
      />

      <div
        v-if="filteredConversationIds.length"
        class="flex flex-wrap gap-2 max-h-40 overflow-y-auto content-start"
      >
        <a
          v-for="conversationId in filteredConversationIds"
          :key="`conversation-${conversationId}`"
          :href="getConversationRoute(conversationId)"
          class="px-2 py-1 text-xs font-medium rounded-md bg-n-alpha-2 text-blue-600 hover:text-blue-700 hover:underline cursor-pointer transition-colors"
        >
          #{{ conversationId }}
        </a>
      </div>
      <div v-else class="text-xs text-n-slate-11 italic">
        {{
          idSearchQuery
            ? t('BROADCASTS.NO_MATCHING_IDS', 'No matching IDs found')
            : t('BROADCASTS.NO_CONVERSATION_IDS')
        }}
      </div>
    </div>
  </div>
</template>
